import { useEffect } from 'react'

import { useOrganizationBrand } from '../useOrganizationBrand'
import { mapConsent } from './utils/mapConsent'
import { setConsentAttributes } from './utils/setConsentAttributes'

export const useBrazeConsentSync = (): void => {
  const { isBrandAgeras } = useOrganizationBrand()

  useEffect(() => {
    if (!isBrandAgeras) {
      return
    }

    const syncConsent = () => {
      const brazeUser = window.braze?.getUser()

      if (!brazeUser) {
        return
      }

      const consent = mapConsent(window.dataLayer ?? [])
      setConsentAttributes(brazeUser, consent)
    }

    syncConsent()

    window.addEventListener('CookieInformationConsentGiven', syncConsent)

    return () => {
      window.removeEventListener('CookieInformationConsentGiven', syncConsent)
    }
  }, [isBrandAgeras])
}
